<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-users" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Facility Personnel</h4>
                <small style="opacity: 0.8;">{{ employees.length || 0 }} staff registered</small>
              </div>
            </div>
            <button class="btn btn-outline-light btn-sm" @click="showadder = !showadder">
              <i class="fe fe-plus mr-1"></i> Add Personnel
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <!-- ── Add Employee Form ── -->
        <div class="card shadow-sm form-card mb-4" v-show="showadder">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-user-plus"></i></div>
            <h6 class="mb-0 font-weight-bold text-white">Add Employee</h6>
          </div>
          <div class="card-body px-4 pt-4 pb-3">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">First Name</label>
                <input type="text" class="form-control" v-model="register.firstname" placeholder="First Name" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Last Name</label>
                <input type="text" class="form-control" v-model="register.lastname" placeholder="Last Name" />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Email</label>
                <input type="email" class="form-control" v-model="register.email" placeholder="Email" />
              </div>
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Phone Number</label>
                <input v-phone type="text" class="form-control" v-model="register.phone_number" placeholder="Phone Number" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">LGA</label>
                <select class="form-control" v-model="register.localgovt" @change="fetchWards($event)">
                  <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">
                    {{ lga.local_name }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Ward</label>
                <select class="form-control" v-model="register.ward" @change="getProvidersByWards($event)">
                  <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">
                    {{ ward.ward_name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small font-weight-bold text-secondary">Job Title</label>
                <select class="form-control" v-model="register.job_title">
                  <option value="Desk">Desk Officer</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Pharmacist">Pharmacist</option>
                  <option value="Nurse">Nurse</option>
                  <option value="Laboratorist">Laboratorist</option>
                  <option value="Accountant">Accountant</option>
                </select>
              </div>
            </div>

            <div class="alert alert-notice d-flex align-items-center mb-3">
              <i class="fe fe-info mr-3" style="font-size: 1.1rem; flex-shrink: 0;"></i>
              <span>The default password for all new employees is <strong>'euhler'</strong>.</span>
            </div>

            <button class="btn btn-submit px-4" @click="registerUser">
              <i class="fe fe-send mr-2"></i> Submit
            </button>
          </div>
        </div>

        <!-- ── Personnel Table ── -->
        <div class="card shadow table-card">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-users text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Personnel</h6>
            <span class="badge badge-soft-info ml-2">{{ employees.length || 0 }}</span>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th px-4">Name</th>
                  <th class="table-th">Email</th>
                  <th class="table-th">Phone Number</th>
                  <th class="table-th"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="employee in employees" v-bind:key="employee.id" class="table-row">
                  <td class="px-4 py-3 font-weight-bold" style="font-size: 0.85rem;">
                    {{ employee.full_name }}
                  </td>
                  <td class="py-3" style="font-size: 0.85rem;">{{ employee.email }}</td>
                  <td class="py-3" style="font-size: 0.85rem;">{{ employee.phone_number }}</td>
                  <td class="py-3">
                    <router-link :to="{ path: '/employee/' + employee.id }">
                      <button type="button" class="btn btn-outline-secondary btn-sm">
                        <i class="fe fe-eye"></i>
                      </button>
                    </router-link>
                  </td>
                </tr>
                <tr v-if="!employees || !employees.length">
                  <td colspan="4" class="text-center py-5 text-muted">
                    <i class="fe fe-users" style="font-size: 2rem; opacity: 0.3;"></i>
                    <p class="mt-2 mb-0">No personnel found</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      states: "",
      showadder: false,
      employees: "",
      state: "",
      lga_states: "",
      wards: "",
      register: {
        firstname: "",
        lastname: "",
        email: "",
        phone_number: "",
        type: "provider_employee",
        state: "",
        username: "",
        institutional_id: "",
        job_title: "",
        lga: "",
        ward: "",
        address: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/getEmployee/${this.$route.params.id}`)
      .then((response) => {
        this.employees = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    getEmployees() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/getEmployee/${this.$route.params.id}`)
        .then((response) => {
          this.employees = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/${event.target.value}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2679`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          firstname: this.register.firstname,
          lastname: this.register.lastname,
          email: this.register.email,
          phone_number: this.register.phone_number,
          type: this.register.type,
          username: this.register.email,
          password: "euhler",
          state: 2679,
          institutional_id: this.$route.params.id,
          job_title: this.register.job_title,
          role: 0,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify(
            "Employee added successfully!, Default Password is 'euhler' ",
            { position: "top-right" }
          );
          this.getEmployees();
          this.clearIt();
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$breadstick.notify("Oops! something went wrong", {
            position: "top-right",
          });
        });
    },
    clearIt() {
      this.register.firstname = "";
      this.register.lastname = "";
      this.register.email = "";
      this.register.phone_number = "";
      this.register.job_title = "";
    },
  },
  created() {
    this.fetchLga();
    this.getEmployees();
  },
};
</script>
